export default __webpack_public_path__ + "bee9a8bfdf112a21b189af4becaaf383.svg";